
import { FiAward, FiBook, FiCode, FiActivity } from "react-icons/fi";

const useCases = [
  {
    icon: <FiAward />,
    title: "Academic Papers",
    description: "Built-in citation management and journal formatting.",
  },
  {
    icon: <FiBook />,
    title: "Thesis Writing",
    description: "Tools for organizing chapters and university-standard formatting.",
  },
  {
    icon: <FiCode />,
    title: "Technical Documentation",
    description: "Support for code blocks and diagrams.",
  },
  {
    icon: <FiActivity />,
    title: "Mathematical Notes",
    description: "High-quality equation rendering for students.",
  },
];

export function UseCasesSection() {
  return (
    <section className="use-cases">
        <h2>Built for every use case</h2>
        <div className="use-case-grid">
            {useCases.map((useCase, index) => (
                <div key={index} className="use-case-card">
                    <div className="use-case-icon">{useCase.icon}</div>
                    <h3>{useCase.title}</h3>
                    <p>{useCase.description}</p>
                </div>
            ))}
        </div>
    </section>
  );
}
